import { apiClient } from "@/services/api";
import { useQuery } from "@tanstack/react-query";

// Query keys
export const aiKeys = {
  all: ["ai"] as const,
  models: () => [...aiKeys.all, "models"] as const,
};

/**
 * Fetch the list of available LLM models for statement extraction.
 *
 * The list is static (defined in the server's model registry), so it is
 * cached for a long time.
 */
export function useAIModels() {
  return useQuery({
    queryKey: aiKeys.models(),
    queryFn: () => apiClient.getAIModels(),
    staleTime: 1000 * 60 * 30, // 30 min
  });
}
